import {
  Injectable,
  ComponentFactoryResolver,
  ViewContainerRef
} from '@angular/core';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ComponentLoader {
  loadChildren: () => Promise<any>;
}

@Injectable()
export class ComponentLoaderService {
  constructor(private cfr: ComponentFactoryResolver) { }

  forChild(vcr: ViewContainerRef, cl: ComponentLoader, params?: any) {
    return from(cl.loadChildren()).pipe(
      map((component: any) => this.cfr.resolveComponentFactory(component)),
      map(componentFactory => {
        let cmp = vcr.createComponent(componentFactory);
        for (const property in params) {
          cmp.instance[property] = params[property];
        }
        return cmp;
      })
    );
  }
}